import { observer } from 'mobx-react-lite'
import Rxs from 'models/Provider/visits/PendingVisit/Rxs'

type PharmacyProps = {
  rxs: Rxs
}

const Pharmacy = ({ rxs }: PharmacyProps) => {
  if (!rxs.length) {
    return null
  }

  return (
    <>
      <h6 className="typography-body-xl text-primary-800 font-medium mb-4">Pharmacy</h6>

      {rxs.map(({ pharmacy }, i) => (
        <div key={i} className="mb-3">
          <p className="typography-body-l text-primary-800">{pharmacy.storeName}</p>
          <p className="typography-body">{pharmacy.address1}</p>
          <p className="typography-body">{pharmacy.address2}</p>
          <p className="typography-body">{pharmacy.phone}</p>
        </div>
      ))}
    </>
  )
}

export default observer(Pharmacy)
